// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SyncDayDrawer_panelContent__Wxw-W {
  padding: 20px 30px;
  min-width: 0;
}

.SyncDayDrawer_panelHeader__quoxv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f4f5f7;
}

.SyncDayDrawer_sectionCount__5TKsY {
  margin-left: 5px;
  font-weight: 400;
  color: #acacac;
  text-transform: none;
  letter-spacing: 0;
}

.SyncDayDrawer_dim__J-Y3f {
  color: #838383;
  font-size: 12px;
  white-space: nowrap;
}

.SyncDayDrawer_closeBtn__Tr6F2 {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #838383;
  line-height: 1;
  padding: 0 5px;
}
.SyncDayDrawer_closeBtn__Tr6F2:hover {
  color: #838383;
  opacity: 0.7;
}

.SyncDayDrawer_meta__K3W15 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.SyncDayDrawer_metaChips__u2JHu {
  display: flex;
  align-items: center;
  gap: 5px;
}

.SyncDayDrawer_section__la\\+Lq {
  margin-bottom: 30px;
}

.SyncDayDrawer_sectionTitle__6tZQ9 {
  font-size: 16.38px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #838383;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.SyncDayDrawer_table__Rskiz {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.SyncDayDrawer_table__Rskiz th {
  text-align: left;
  padding: 5px 10px;
  border-bottom: 2px solid #dbdbdb;
  color: #838383;
  font-weight: 600;
}
.SyncDayDrawer_table__Rskiz td {
  padding: 5px 10px;
  border-bottom: 1px solid #f4f5f7;
  vertical-align: top;
}
.SyncDayDrawer_table__Rskiz tr:last-child td {
  border-bottom: none;
}

.SyncDayDrawer_mono__FBIOR {
  font-family: monospace;
  font-size: 11px;
  word-break: break-all;
}

.SyncDayDrawer_pairBadge__PibR6 {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  white-space: nowrap;
  text-transform: uppercase;
}

.SyncDayDrawer_pairBadgePrimary__orSHs {
  background: rgba(87, 188, 143, 0.18);
  color: #2d8758;
  border: 1px solid rgba(87, 188, 143, 0.4);
}

.SyncDayDrawer_pairBadgeDup__GsX9W {
  background: rgba(142, 106, 203, 0.18);
  color: #6244a0;
  border: 1px solid rgba(142, 106, 203, 0.4);
}

.SyncDayDrawer_pairDup__1VRMQ td {
  background: rgba(142, 106, 203, 0.05);
}

.SyncDayDrawer_error__QrdoW {
  color: #df6767;
  font-size: 12px;
}

.SyncDayDrawer_errorMsg__06Vc0 {
  color: #df6767;
  margin: 20px 0;
}

.SyncDayDrawer_loaderWrap__eiUhi {
  display: flex;
  justify-content: center;
  padding: 30px;
}

.SyncDayDrawer_chip__WByNe {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.SyncDayDrawer_chip_processed__FM-Qu {
  background: var(--accent-color);
}

.SyncDayDrawer_chip_processing__XMRSm {
  background: #3b7fd4;
}

.SyncDayDrawer_chip_pending__QajfH {
  background: #00bcd4;
}

.SyncDayDrawer_chip_waiting_archive__5Xa1e {
  background: #64b5f6;
}

.SyncDayDrawer_chip_duplicate__-GvR3 {
  background: #8e6acb;
}

.SyncDayDrawer_chip_upload_failed__UzQc6 {
  background: #efa12c;
}

.SyncDayDrawer_chip_failed__gEKFG {
  background: #df6767;
}

.SyncDayDrawer_chip_no_data__PFu4R {
  background: #7a7a7a;
}

.SyncDayDrawer_chip_pair_processed__F3dtr {
  background: var(--accent-color);
}

.SyncDayDrawer_chip_duplicate_processed__LKDNS {
  background: #8e6acb;
}

.SyncDayDrawer_chip_waiting_archive__5Xa1e {
  background: #64b5f6;
}

.SyncDayDrawer_chip_sent__ZZgZt {
  background: var(--accent-color);
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/SyncDayDrawer/SyncDayDrawer.module.scss","webpack://./src/_common/scss/_variables.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBCDS;EDET,oBCHS;EDIT,gCAAA;AAFF;;AAKA;EACE,gBCTS;EDUT,gBAAA;EACA,cEZS;EFaT,oBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cEjBS;EFkBT,eAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cE3BS;EF4BT,cAAA;EACA,cAAA;AAFF;AAIE;EACE,cEhCO;EFiCP,YAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SCvCS;EDwCT,mBCvCS;EDwCT,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QChDS;AD6CX;;AAMA;EACE,mBCjDU;AD8CZ;;AAMA;EACE,kBC3Ca;ED4Cb,gBAAA;EACA,kBC1DS;ED2DT,cE3DS;EF4DT,yBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAHF;AAKE;EACE,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,cEzEO;EF0EP,gBAAA;AAHJ;AAME;EACE,iBAAA;EACA,gCAAA;EACA,mBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;;AASA;EACE,sBAAA;EACA,eAAA;EACA,qBAAA;AANF;;AASA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AANF;;AASA;EACE,oCAAA;EACA,cAAA;EACA,yCAAA;AANF;;AASA;EACE,qCAAA;EACA,cAAA;EACA,0CAAA;AANF;;AASA;EACE,qCAAA;AANF;;AASA;EACE,cEtHM;EFuHN,eAAA;AANF;;AASA;EACE,cE3HM;EF4HN,cAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,aCxIW;ADkIb;;AAWA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,WE5IM;EF6IN,yBAAA;EACA,sBAAA;AARF;;AAYA;EAAyB,+BE9JhB;AFsJT;;AASA;EAAyB,mBAAA;AALzB;;AAMA;EAAyB,mBAAA;AAFzB;;AAGA;EAAyB,mBAAA;AACzB;;AAAA;EAAyB,mBAAA;AAIzB;;AAHA;EAAyB,mBAAA;AAOzB;;AANA;EAAyB,mBEzJjB;AFmKR;;AATA;EAAyB,mBAAA;AAazB;;AAVA;EAA4B,+BExKnB;AFsLT;;AAbA;EAA4B,mBAAA;AAiB5B;;AAhBA;EAA4B,mBAAA;AAoB5B;;AAnBA;EAA4B,+BE3KnB;AFkMT","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.panelContent {\n  padding: $padding-l $padding-xl;\n  min-width: 0;\n}\n\n.panelHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: $margin-l;\n  padding-bottom: $margin-m;\n  border-bottom: 1px solid $grey-100;\n}\n\n.sectionCount {\n  margin-left: $margin-s;\n  font-weight: 400;\n  color: $grey-300;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.dim {\n  color: $grey-400;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: $grey-400;\n  line-height: 1;\n  padding: 0 $padding-s;\n\n  &:hover {\n    color: $grey-400;\n    opacity: 0.7;\n  }\n}\n\n.meta {\n  display: flex;\n  align-items: center;\n  gap: $margin-m;\n  margin-bottom: $margin-l;\n  flex-wrap: wrap;\n}\n\n.metaChips {\n  display: flex;\n  align-items: center;\n  gap: $margin-s;\n}\n\n.section {\n  margin-bottom: $margin-xl;\n}\n\n.sectionTitle {\n  font-size: $h3-font-size;\n  font-weight: 600;\n  margin-bottom: $margin-s;\n  color: $grey-400;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n\n  th {\n    text-align: left;\n    padding: $padding-s $padding-m;\n    border-bottom: 2px solid $grey-200;\n    color: $grey-400;\n    font-weight: 600;\n  }\n\n  td {\n    padding: $padding-s $padding-m;\n    border-bottom: 1px solid $grey-100;\n    vertical-align: top;\n  }\n\n  tr:last-child td {\n    border-bottom: none;\n  }\n}\n\n.mono {\n  font-family: monospace;\n  font-size: 11px;\n  word-break: break-all;\n}\n\n.pairBadge {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n  text-transform: uppercase;\n}\n\n.pairBadgePrimary {\n  background: rgba(87, 188, 143, 0.18);\n  color: #2d8758;\n  border: 1px solid rgba(87, 188, 143, 0.4);\n}\n\n.pairBadgeDup {\n  background: rgba(142, 106, 203, 0.18);\n  color: #6244a0;\n  border: 1px solid rgba(142, 106, 203, 0.4);\n}\n\n.pairDup td {\n  background: rgba(142, 106, 203, 0.05);\n}\n\n.error {\n  color: $error;\n  font-size: 12px;\n}\n\n.errorMsg {\n  color: $error;\n  margin: $margin-l 0;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: $padding-xl;\n}\n\n// ─── Status chip ─────────────────────────────────────────────────────────────\n\n.chip {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $white;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n// Day-level status chips\n.chip_processed        { background: $accent; }\n.chip_processing       { background: #3b7fd4; }\n.chip_pending          { background: #00bcd4; }\n.chip_waiting_archive  { background: #64b5f6; }\n.chip_duplicate        { background: #8e6acb; }\n.chip_upload_failed    { background: #efa12c; }\n.chip_failed           { background: $error; }\n.chip_no_data          { background: #7a7a7a; }\n\n// Raw ingestion / S3 file statuses (used inside the tables)\n.chip_pair_processed      { background: $accent; }\n.chip_duplicate_processed { background: #8e6acb; }\n.chip_waiting_archive     { background: #64b5f6; }\n.chip_sent                { background: $accent; }\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelContent": `SyncDayDrawer_panelContent__Wxw-W`,
	"panelHeader": `SyncDayDrawer_panelHeader__quoxv`,
	"sectionCount": `SyncDayDrawer_sectionCount__5TKsY`,
	"dim": `SyncDayDrawer_dim__J-Y3f`,
	"closeBtn": `SyncDayDrawer_closeBtn__Tr6F2`,
	"meta": `SyncDayDrawer_meta__K3W15`,
	"metaChips": `SyncDayDrawer_metaChips__u2JHu`,
	"section": `SyncDayDrawer_section__la+Lq`,
	"sectionTitle": `SyncDayDrawer_sectionTitle__6tZQ9`,
	"table": `SyncDayDrawer_table__Rskiz`,
	"mono": `SyncDayDrawer_mono__FBIOR`,
	"pairBadge": `SyncDayDrawer_pairBadge__PibR6`,
	"pairBadgePrimary": `SyncDayDrawer_pairBadgePrimary__orSHs`,
	"pairBadgeDup": `SyncDayDrawer_pairBadgeDup__GsX9W`,
	"pairDup": `SyncDayDrawer_pairDup__1VRMQ`,
	"error": `SyncDayDrawer_error__QrdoW`,
	"errorMsg": `SyncDayDrawer_errorMsg__06Vc0`,
	"loaderWrap": `SyncDayDrawer_loaderWrap__eiUhi`,
	"chip": `SyncDayDrawer_chip__WByNe`,
	"chip_processed": `SyncDayDrawer_chip_processed__FM-Qu`,
	"chip_processing": `SyncDayDrawer_chip_processing__XMRSm`,
	"chip_pending": `SyncDayDrawer_chip_pending__QajfH`,
	"chip_waiting_archive": `SyncDayDrawer_chip_waiting_archive__5Xa1e`,
	"chip_duplicate": `SyncDayDrawer_chip_duplicate__-GvR3`,
	"chip_upload_failed": `SyncDayDrawer_chip_upload_failed__UzQc6`,
	"chip_failed": `SyncDayDrawer_chip_failed__gEKFG`,
	"chip_no_data": `SyncDayDrawer_chip_no_data__PFu4R`,
	"chip_pair_processed": `SyncDayDrawer_chip_pair_processed__F3dtr`,
	"chip_duplicate_processed": `SyncDayDrawer_chip_duplicate_processed__LKDNS`,
	"chip_sent": `SyncDayDrawer_chip_sent__ZZgZt`
};
export default ___CSS_LOADER_EXPORT___;
